var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotificationmanagement({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 29,
    viewBox: "0 0 25 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9091 22.4545V23.5909C15.9091 24.4951 15.5499 25.3622 14.9106 26.0015C14.2713 26.6408 13.4041 27 12.5 27C11.5959 27 10.7287 26.6408 10.0894 26.0015C9.45008 25.3622 9.09091 24.4951 9.09091 23.5909V22.4545M3.40909 22.4545V11.0909C3.40909 8.67985 4.36688 6.36754 6.07176 4.66267C7.77663 2.95779 10.0889 2 12.5 2C14.9111 2 17.2234 2.95779 18.9282 4.66267C20.6331 6.36754 21.5909 8.67985 21.5909 11.0909V22.4545H3.40909ZM0 22.4545H25H0Z",
    stroke: "#5282F0",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationmanagement);
export default __webpack_public_path__ + "static/media/notificationmanagement.29eec267ddb20fe7b6893ab64c369d36.svg";
export { ForwardRef as ReactComponent };